import React, { useState } from "react";
import { auth } from "../firebase/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import "../styles/login.css";
import "../App.css";

function Login({ onForgotPassword }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const firebaseErrorMessages = {
    "auth/invalid-email": "Please enter a valid email address.",
    "auth/user-disabled": "This account has been disabled. Contact support.",
    "auth/user-not-found": "No account found with this email.",
    "auth/wrong-password": "Incorrect password. Please try again.",
    "auth/invalid-credential": "Invalid email or password. Please try again.",
    "auth/email-already-in-use": "This email is already registered. Try logging in.",
    "auth/weak-password": "Password is too weak. Use at least 6 characters.",
    "auth/missing-password": "Please enter your password.",
    "auth/too-many-requests": "Too many failed attempts. Please try again later.",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      const message =
        firebaseErrorMessages[err.code] || "Something went wrong. Please try again.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

 return (
    <div className={`login-container ${loading ? "loading-overlay" : ""}`}>
      {loading && (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-logo">
          <img
            className="login-image"
            src={require("../images/logo.png")}
            alt="CIET Logo"
          />
        </div>
        <h1 className="login-title" style={{ fontSize: "1.6rem", color: "var(--color-primary)", marginBottom: "0" }}>
          Learner Portal
        </h1>
        <h1 className="login-title">Sign in to access resources</h1>

        {error && <div className="error-box">{error}</div>}

        <div className="form-group">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="form-input"
            required
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="form-input"
            required
            disabled={loading}
          />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          Login
        </button>

        <div className="login-options">
          <p onClick={onForgotPassword} className="link">
            Forgot password?
          </p>
        </div>
      </form>
    </div>
  );
}

export default Login;
